import { useFormikContext } from 'formik'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { fireStore } from '~/stores'
import { observer } from '~/common/mobx.decorator'
import { useEffectOnce } from 'react-use'
import { isEmpty } from 'lodash'
import { NotifyDialog } from '../notify'
import { Typography } from '../typography'
import { useTranslation } from '@opus/web.core.hooks.use-translation'

export const OfflineSync = observer(({ collection, message, onClickContinue, onClickCancel }) => {
	const { t } = useTranslation()
	const [initialized, setInitialized] = useState(false)
	const [notifyData, showNotify] = useState()

	const docRef = useMemo(
		() => fireStore.db.collection(collection).doc(fireStore.fid),
		// eslint-disable-next-line
		[fireStore.fid, collection]
	)

	const { values, dirty, setValues, initialValues, errors } = useFormikContext()

	useEffect(() => {
		if (initialized) {
			docRef.set({ values, errors, initialValues, dirty })
		}
	}, [values, errors, initialValues, dirty, docRef, initialized])

	useEffectOnce(() => {
		docRef
			.get()
			.then((doc) => {
				const data = doc.data()

				if (isEmpty(data)) {
					return
				}

				if (!data.dirty) {
					return docRef.delete()
				}

				if (message) {
					showNotify(data)
				} else {
					setValues(data.values)
				}
			})
			.finally(() => setInitialized(true))
	})

	const handleClearFireValues = useCallback(() => {
		docRef.delete()
		showNotify(null)
		if (typeof onClickCancel === 'function') {
			onClickCancel()
		}
	}, [docRef, onClickCancel])

	const handleContinue = useCallback(() => {
		setValues(notifyData.values)

		if (typeof onClickContinue === 'function') {
			onClickContinue()
		}

		setTimeout(() => {
			showNotify(null)
		}, 500)
	}, [notifyData, setValues, onClickContinue])

	return (
		<>
			<NotifyDialog open={!isEmpty(notifyData)} onOk={handleContinue} onCancel={handleClearFireValues} cancelText="DISCARD" okText="CONTINUE">
				<Typography whiteSpace="pre-line" align="center">
					{t(message)}
				</Typography>
			</NotifyDialog>
		</>
	)
})

OfflineSync.defaultProps = {
	offlineTime: 600,
}
